import React from 'react'

import { ProductionItems, ProductionItemsTitle } from './ProductionItems'
import classes from './ProductionTablet.module.scss'

export const AboutUsProductionTablet: React.FC = () => {
  return (
    <div className="container">
      <h2 className={`second-title ${classes.title}`}>
        {ProductionItemsTitle}
      </h2>
      {ProductionItems.map((item, itemIndex) => (
        <div
          key={`AboutUsProductionMobile_${itemIndex}`}
          className={classes.item}
        >
          <div className={classes.item__title}>{item.title}</div>
          <div className={classes.item__descr}>{item.descr}</div>
        </div>
      ))}
    </div>
  )
}
